// components/Blog/CardGrid.jsx

import React, { useState, useMemo, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchArticlesFromWordpress } from "../../Services/Actions/WordpressApi";
import { AiOutlineFileSearch } from "react-icons/ai";

const decodeHtml = (html) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

const itemsPerPage = 6;

const MyCardGrid = () => {
  const params = useParams();
  const [articles, setArticles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  console.log(params);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const formatted = await fetchArticlesFromWordpress();
        setArticles(formatted);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [params.slug]);

  const matchedArticles = useMemo(() => {
    if (params.slug === "all") return articles;
    if (!params.slug) return articles;
    return articles.filter(
      (item) =>
        Array.isArray(item.categorySlugs) &&
        item.categorySlugs.includes(params.slug)
    );
  }, [articles, params.slug]);

  const totalPages = Math.ceil(matchedArticles.length / itemsPerPage);

  const currentArticles = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return matchedArticles.slice(start, start + itemsPerPage);
  }, [matchedArticles, currentPage]);

  const randomVideo = useMemo(() => {
    const vids = dummyData.filter(
      (item) => !params.slug || (item.categorySlugs || []).includes(params.slug)
    );
    if (!vids.length) return null;
    return vids[Math.floor(Math.random() * vids.length)];
  }, [params.slug]);

  return (
    <div className="my-card-grid">
      {loading && <p className="loading-message">Loading articles...</p>}
      {error && <p className="error-message">{error}</p>}

      <div className="small-cards-row">
        {!loading &&
          currentArticles.length > 0 &&
          currentArticles.map((item) => (
            <SmallCard key={item.id} item={item} previousSlug={params.slug} />
          ))}
      </div>

      <div className="product-feature">
        {randomVideo && <VideoCard item={randomVideo} />}
      </div>

      <div className="pagination-container">
        {totalPages > 1 && (
          <>
            <button
              className="nav-button"
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >
              <img src="../assets/images/Blog/arrow-left.svg" alt="Prev" />
              Previous
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .slice(
                Math.max(currentPage - 2, 0),
                Math.min(currentPage + 1, totalPages)
              )
              .map((p) => (
                <button
                  key={p}
                  className={`page-button ${p === currentPage ? "active" : ""}`}
                  onClick={() => setCurrentPage(p)}
                >
                  {p}
                </button>
              ))}
            <button
              className="nav-button"
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
              <img src="../assets/images/Blog/arrow-right.svg" alt="Next" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const SmallCard = ({ item, previousSlug }) => {
  const navigate = useNavigate();
  const { id, slug, title, date, image, excerpt } = item;

  return (
    <div
      className="small-card"
      onClick={() => {
        const pathSegment = slug ? slug : id;
        navigate(`/blog-details/${pathSegment}?${previousSlug}`);
      }}
    >
      <img
        src={image}
        alt={decodeHtml(title) || "Article"}
        className="small-card-img"
      />
      <div className="small-card-content">
        <h4 dangerouslySetInnerHTML={{ __html: title }} />
        <div
          className="card-description"
          dangerouslySetInnerHTML={{ __html: excerpt }}
        />
        <div className="dateprofile">
          <img src="../assets/images/Blog/calendar.svg" alt="Calendar" />
          <p className="card-date">{date}</p>
        </div>
      </div>
    </div>
  );
};

const VideoCard = ({ item }) => {
  if (!item) return null;
  const { title, date, videoUrl, description } = item;
  return (
    <div className="video-container">
      <h1>Product Feature</h1>
      <div className="video-card">
        <div className="video-box">
          <video controls src={videoUrl} />
        </div>
        <div className="video-card-content">
          <h3>{title}</h3>
          <p className="card-description">{description}</p>
        </div>
      </div>
    </div>
  );
};

const dummyData = [
  {
    id: 1,
    title: "Forward calls to your mobile device using Nxatel",
    date: "6 May, 2025",
    categorySlugs: [
      "all",
      "start-ups",
      "remote-hybrid-work",
      "sales-support",
      "product-updates",
      "customer-stories",
      "ms-teams-integrations",
      "ai-trends",
      "security",
      "smart-city",
    ],
    image: "../assets/images/Blog/avataricon.svg",
    type: "video",
    videoUrl:
      "../assets/images/Blog/How to Forward Number to Mobile number professionally.mp4",
    description:
      "Forward calls professionally to your mobile number to improve your customer experience from anywhere, anytime.",
  },
];

export default MyCardGrid;
